<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-google-classroom" title="Upload Videos">
        <v-card-actions>
          <router-link :to="{ name: 'videoUploadList' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="onSubmit" enctype="multipart/form-data" name="videoUploadForm">
            <v-row>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">
                  Select Franchisee
                  <span class="error--text">*</span></label
                >
                <v-autocomplete
                  placeholder="--Select--"
                  name="selectFranchisee"
                  required
                  v-model="franchiseeID"
                  v-on:change="getClassList"
                  item-value="id"
                  :items="franchiseeArr"
                  key="id"
                  item-text="companyName"
                  class="my-0 py-1"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">
                  Class
                  <span class="error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  name="classSelect"
                  v-model="selectedClassID"
                  required
                  v-on:change="changeSections()"
                  item-value="id"
                  :items="classes"
                  key="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">
                  Section
                  <span class="error--text">*</span>
                </label>
                <v-autocomplete
                  placeholder="--Select--"
                  name="sectionSelect"
                  v-model="selectedSectionID"
                  required
                  item-value="id"
                  :items="classWiseSections"
                  class="my-0 py-1"
                  key="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">
                  Click to Upload
                  <span class="error--text">*</span>
                </label>
                <v-file-input :messages="['(max file size allowed 20MB)']" v-model="dropFiles" @input="csvToJsonInput(dropFiles)" placeholder="mp4 only" class="my-0 py-1" show-size accept="video/mp4" single-line></v-file-input>
                <v-progress-circular v-if="isProgressBarVisible" :rotate="360" :size="100" :width="15" :value="Number(uploadPercentage)" color="success">
                  {{ Number(uploadPercentage) }}
                </v-progress-circular>
              </v-col>
              <v-col cols="12">
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn :disabled="isDisableUpload" type="submit" elevation="1" color="primary">
                    <v-icon left> mdi-upload </v-icon>
                    Upload
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'

export default {
  name: 'uploadVideoS3',
  components: {
    MaterialCard
  },
  data () {
    return {
      jsonData: [],
      franchiseeID: '',
      classID: '',
      isLoading: false,
      classes: [],
      selectedClassID: '',
      selectedSectionID: '',
      dropFiles: null,
      franchiseeArr: [],
      totalCount: '',
      disableUpload: false,
      paginated: false,
      sections: [],
      classWiseSections: [],
      perPage: 10,
      loadingComponent: null
    }
  },
  async created () {
    try {
      await this.getFranchiseeList()
    } catch (e) {
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }
  },
  computed: {
    ...mapState(['isDisableUpload', 'isProgressBarVisible', 'uploadPercentage', 'videoName']),
    ...mapGetters({
      isDisableUpload: 'isDisableUpload',
      uploadPercentage: 'uploadPercentage',
      isProgressBarVisible: 'isProgressBarVisible',
      videoName: 'videoName',
      updateVisibilityStatus: 'updateVisibilityStatus',
      updateVideoName: 'updateVideoName'
    }),
    videoName () {
      return this.$store.state.videoName
    }
  },
  methods: {
    changeSections: async function () {
      let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
      if (sectionarray) {
        this.classWiseSections = sectionarray.sections
        this.selectedSectionID = ''
      } else {
        this.classWiseSections = []
        this.selectedSectionID = ''
      }
    },
    getClassList: async function () {
      try {
        if (!this.franchiseeID) {
          return
        }
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&isAllValue=true`)

        this.isLoading = false
        if (data) {
          this.classes = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map(obj => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        if (data) {
          this.franchiseeArr = data.rows
        } else {
          this.franchiseeArr = []
        }
        this.isLoading = false
        await this.getClassList()
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    deleteDropFile (index) {
      this.isResponse = false
      this.dropFiles = null
    },
    async onSubmit (event) {
      if (!this.dropFiles) {
        return this.$dialog.message.info('Please upload video file!', {
          position: 'top',
          timeout: 5000
        })
      }
      this.hasClicked = true
      this.loader = true
      try {
        if (this.dropFiles) {
          if (this.dropFiles.size > 600 * 1024 * 1024) {
            return this.$dialog.error({
              title: 'Error',
              text: 'Video size must be less than 600 MB!'
            })
          }
        }
        let query = { name: this.dropFiles.name, franchiseeID: this.franchiseeID, classID: this.selectedClassID, sectionID: this.selectedSectionID }

        this.isLoading = true
        let response = await http.get(`${constants.API_URL}/api/franchisee/get-video-by-name`, {
          params: query
        })

        this.isLoading = false
        let message = `Do we start uploading video?`
        if (response.data) {
          message = 'Video already exists!<br>Do we replace existing video ?'
        }
        this.$dialog.warning({
          text: message,
          title: 'Warning',
          actions: {
            false: {
              text: 'No',
              handle: () => {
                return 0
              }
            },
            true: {
              color: 'red',
              text: 'Yes',
              handle: async () => {
                try {
                  let filename = `Uploading:- ${this.dropFiles.name}`
                  this.$store.commit('updateVisibilityStatus', true, filename)
                  this.$store.commit('updateVideoName', filename)
                  let formData = new FormData()
                  formData.append('franchiseeID', this.franchiseeID)
                  formData.append('classID', this.selectedClassID)
                  formData.append('sectionID', this.selectedSectionID)
                  formData.append('file', this.dropFiles)
                  await http.post(`${constants.API_URL}/api/franchisee/upload-videos`, formData, {
                    onUploadProgress: progressEvent => {
                      let uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
                      this.$store.commit('updateUploadPercentage', uploadPercentage)
                    }
                  })
                  await this.deleteDropFile(0)
                  return this.$dialog.confirm({
                    title: 'Success !',
                    text: 'Video received!<br> Uploading will complete in some time!'
                  })
                } catch (e) {
                  const errorMessage = (e && e.response && e.response.data.message) || e.message
                  console.log(errorMessage)

                  return this.$dialog.error({
                    text: 'Error While uploading  video! <br> retry uploading video',
                    title: 'Error'
                  })
                } finally {
                  this.$store.commit('updateVisibilityStatus', false)
                  this.$store.commit('updateUploadPercentage', 0)
                }
              }
            }
          }
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)

        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
      }
    },
    csvToJsonInput: async function (files) {
      this.dropFiles = files
    }
  }
}
</script>
<style></style>
